import { RouteConfig } from 'vue-router';

const MyModel = () => import(/* webpackChunkName: "Model" */  './views/my-model/my-model.vue');
const CreateModel = () => import(/* webpackChunkName: "Model" */  './views/create-model/create-model.vue');
const ModelTrain = () => import(/* webpackChunkName: "Model" */  './views/model-train/model-train.vue');
const ModelTrial = () => import(/* webpackChunkName: "Model" */  './views/model-trial/model-trial.vue');
const ModelReport = () => import(/* webpackChunkName: "Model" */  './views/model-report/model-report.vue');



const routers: RouteConfig[] = [
    {
        path: 'my-model',
        component: MyModel
    },
    {
        path: 'create-model',
        component: CreateModel
    },
    {
        path: 'create-model/:type',
        component: CreateModel
    },
    {
        path: 'model-train',
        component: ModelTrain
    },
    {
        path: 'model-train/:model_id',
        component: ModelTrain
    },
    {
        path: 'model-trial',
        component: ModelTrial
    },
    {
        path: 'model-trial/:model_id',
        component: ModelTrial
    },
    {
        path: 'model-report/:model_id',
        component: ModelReport
    },
    {
        path: 'model-report/:model_id/:version_id',
        component: ModelReport
    },
    {
        path: '',
        redirect: 'my-model'
    },
];

export default routers;

